import React from "react";

const Summary = (props) => {
  const translateText = (LabelId) => {
    var Filter = "label_id";
    var Keyword = LabelId;
    var Label = props.LangData.filter((Obj) => {
      return Obj[Filter] === Keyword;
    });
    return Label[0].label_value;
  };

  return (
    <div className="summary-wrapper">
      <p className="summary-title">{translateText("total_statistics")}</p>
      <div className="summary-items">
        <section className="summary-item">
          <i className="feather-user-check"></i>
          <p className="count-info">
            {props.AllApplicationsCount === NaN
              ? null
              : props.AllApplicationsCount}
          </p>
          <p className="smaill-info">{translateText("all_applications")}</p>
        </section>
        <section className="summary-item">
          <i className="feather-briefcase"></i>
          <p className="count-info">
            {props.AllJobsCount + "/" + props.AcceptedJobsCount}
          </p>
          <p className="smaill-info">
            {window.innerWidth <= 450
              ? translateText("all") + "/" + translateText("accepted_jobs")
              : translateText("all_job_applications") +
                "/" +
                translateText("accepted_jobs")}
          </p>
        </section>
        <section className="summary-item">
          <i className="feather-clipboard"></i>
          <p className="count-info">
            {props.AllProjectsCount + "/" + props.AcceptedProjectsCount}
          </p>
          <p className="smaill-info">
            {window.innerWidth <= 450
              ? translateText("all") + "/" + translateText("accepted_projects")
              : translateText("all_project_applications") +
                "/" +
                translateText("accepted_projects")}
          </p>
        </section>
        <section className="summary-item">
          <i className="feather-activity"></i>
          <p className="count-info">
            {props.AllActivitiesCount + "/" + props.AcceptedActivitiesCount}
          </p>
          <p className="smaill-info">
            {window.innerWidth <= 450
              ? translateText("all") +
                "/" +
                translateText("accepted_activities")
              : translateText("all_activity_applications") +
                "/" +
                translateText("accepted_activities")}
          </p>
        </section>
      </div>
    </div>
  );
};

export default Summary;
